import React from 'react';
import { newsData } from '../NewsData/NewsData';
import './NewsList.css';

function NewsList() {
  return (
    <section className="news-list-container">
      <div className="table-contents">
        {Object.keys(newsData).reverse().map(year => (
          <div key={year} className="table-column">
            <div className="column-heading">
              <div className="title">{year}</div>
            </div>
            <div className="links">
              {newsData[year].map((article, index) => (
                <div key={index}>
                  <a 
                  // href={article.url}
                   target="_blank" rel="noopener noreferrer" className="animated-link">
                    <div className="txt">{article.title}</div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default NewsList;